/**
 * Preview URL Value Object
 * Represents a temporary preview URL for accessing PASCO JPG preview images
 */
export interface PreviewUrlProps {
    previewUrl: string;
    expiresAt: Date;
    pascoId: string;
}

export class PreviewUrl {
    private constructor(private readonly props: PreviewUrlProps) { }

    static create(props: PreviewUrlProps): PreviewUrl {
        return new PreviewUrl(props);
    }

    get previewUrl(): string {
        return this.props.previewUrl;
    }

    get expiresAt(): Date {
        return this.props.expiresAt;
    }

    get pascoId(): string {
        return this.props.pascoId;
    }

    /**
     * Check if the URL has expired
     */
    isExpired(): boolean {
        return new Date() > this.props.expiresAt;
    }

    /**
     * Get time remaining until expiration in milliseconds
     */
    getTimeRemaining(): number {
        return Math.max(0, this.props.expiresAt.getTime() - new Date().getTime());
    }

    /**
     * Check if URL will expire soon (within 5 minutes)
     */
    isExpiringSoon(): boolean {
        const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
        return this.getTimeRemaining() <= fiveMinutes;
    }
}
